import urlJoin from "helpers/urljoin";
import config from "config";
import axios from "axios";
import { UNIVERSITY_ICON } from "constants/configConstants";
import styles from "./mapSection.module.scss";

import { isEmptyObject } from "helpers/validations";

export const calculateDistance = (
  data: any,
  regionObject: any,
  map: any,
  regionMarker: any,
  setDistanceObj: any,
  inventoryMarker: any,
  isDropdown?: boolean,
) => {
  const inventoryLocationCoordinates: any = data?.location_coordinates || {};
  const universityCoordinates = regionObject?.location?.location_coordinates || {};
  const distanceObj: any = {};
  let callsToCalcDistance = 0;

  if (isEmptyObject(inventoryLocationCoordinates) && isEmptyObject(universityCoordinates)) return;
  const calculateDistanceForRequest = async (type: any) => {
    const options = {
      url: urlJoin(config.API_URL, "/api/v0/regions/distances/fetch"),
      params: {
        destinations: `${inventoryLocationCoordinates?.lat},${inventoryLocationCoordinates?.lng}`,
        origins: `${universityCoordinates?.lat},${universityCoordinates?.lng}`,
        mode: type.toLowerCase(),
        units: "imperial",
      },
    };

    try {
      const { data: dataFromApi } = await axios.get(options.url, { params: options.params });
      const { data: result }: any = dataFromApi?.data;
      const { status } = result;
      if (status === "OK") {
        distanceObj[type] = {
          distance: result.distance.text,
          duration: result.duration.text,
        };
      }

      // eslint-disable-next-line no-plusplus
      callsToCalcDistance++;
      if (callsToCalcDistance === 3) {
        setDistanceObj(distanceObj);

        // Reset university marker
        if (google.maps !== undefined) {
          if (isDropdown) {
            if (regionMarker.current) regionMarker.current.setMap(null);

            const markerOptions = {
              map,
              position: new google.maps.LatLng(
                regionObject.location.location_coordinates.lat,
                regionObject.location.location_coordinates.lng,
              ),
              label: {
                text: regionObject.name,
                className: styles.mapMarkerLabelInitial,
              },
              icon: {
                url: UNIVERSITY_ICON.url,
                scaledSize: new google.maps.Size(
                  UNIVERSITY_ICON.scaledSize.width,
                  UNIVERSITY_ICON.scaledSize.height,
                ),
              },
            };

            // University Marker
            regionMarker.current = new google.maps.Marker(markerOptions);

            // Set Map bounds
            const bounds = new google.maps.LatLngBounds();
            if (regionMarker.current) {
              bounds.extend(regionMarker.current.getPosition());
            }
            if (inventoryMarker.current) {
              bounds.extend(inventoryMarker.current.getPosition());
            }
            map.fitBounds(bounds);
            map.setZoom(map.getZoom() - 1.5);
            // map.setHeading(90)
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  calculateDistanceForRequest("DRIVING");
  calculateDistanceForRequest("TRANSIT");
  calculateDistanceForRequest("WALKING");
};

export const getQueryParams = () => {
  const queryParams: any = {};
  if (typeof window !== "undefined") {
    const urlObj = new URL(window.location.href);
    for (const [key, value] of urlObj.searchParams.entries()) {
      queryParams[key] = value;
    }
  }
  return queryParams;
};

export const getMapMarkerIconUrl = (name: string, isSelected = false) => {
  if (isSelected) {
    return `${config.IMAGE_STATIC_URL}/assets/maps_active_marker.svg`;
  }

  switch (name) {
    case "Universities":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_nearby_universities.svg`;

    case "Bus Stations":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_bus_stops.svg`;

    case "Train Stations":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_train_stations.svg`;

    case "Supermarkets":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_shopping.svg`;

    case "Pharmacies":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_pharmacy.svg`;

    case "Restaurants":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_restaurants.svg`;

    case "Property":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_current_property.svg`;

    case "Active Marker":
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_active_marker.svg`;

    default:
      return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/maps_active_marker.svg`;
  }
};
export const getFilteredUniversityFromLocal = (
  universities: [],
  selectedUniversityFromLocal: string,
) => {
  const filteredOptions = universities?.filter(
    (uni: any) =>
      uni?.name?.toLowerCase()?.includes(selectedUniversityFromLocal?.split(" -")[0].toLowerCase()), // saved in local storage when univ filters added
  )[0];
  return filteredOptions;
};
